import React from "react";
import { format } from "date-fns";

import HolidayItem from "components/Screens/HolidaySchedule/components/HolidayItem/HolidayItem";

import { groupHolidaysByDate } from "components/Screens/HolidaySchedule/utils";

import "./HolidayMonthGroup.scss";

function HolidayMonthGroup({ monthYear, holidays, today, onHolidayClick, monthRef, upcomingDateKey }) {
  const groupedByDate = groupHolidaysByDate(holidays);

  return (
    <div className="holiday-month-group">
      <p className="holiday-month-title" ref={monthRef}>
        {monthYear === format(today, "MMMM, yyyy") ? `This month (${monthYear})` : monthYear}
      </p>

      <div className="holiday-items">
        {groupedByDate.map((holidaysOnDate) => {
          const uniqueKey = holidaysOnDate
            .map((h) => (h.id ? `${h.id}-day${h.dayNumber || 1}` : `${h.name}-${h.region}-day${h.dayNumber || 1}`))
            .join("-");
          return (
            <HolidayItem
              key={`${holidaysOnDate[0].startDate}-${uniqueKey}`}
              holidaysOnDate={holidaysOnDate}
              onHolidayClick={onHolidayClick}
              upcomingDateKey={upcomingDateKey}
            />
          );
        })}
      </div>
    </div>
  );
}

export default HolidayMonthGroup;
